import { render, staticRenderFns } from "./walletPage.vue?vue&type=template&id=2d7a2b60&scoped=true"
import script from "./walletPage.vue?vue&type=script&lang=js"
export * from "./walletPage.vue?vue&type=script&lang=js"
import style0 from "./walletPage.vue?vue&type=style&index=0&id=2d7a2b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a2b60",
  null
  
)

export default component.exports